export enum AvlVendorType {
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
}
